module.exports = __webpack_public_path__ + "static/media/photo155.e997734c.jpg";